import React, { useEffect } from 'react'
import Cookies from "universal-cookie";
import { useRouter } from 'next/router';

import useGlobalState from './context';
import { getStatus, getAccount } from '../libs/requests';

const withAuth = (WrappedComponent) => {
  
  const FuncComponent = ({ children, ...props }) => {
    const { user, setUser } = useGlobalState(); 
    const router = useRouter();

    useEffect(() => {
      if (!user && props.user && props.account) {
        setUser(props.user, props.account);
      } else if (!user && !props.user) {
        // Redirect to home if not authenticated
        router?.push('/');
      }
    }, [user, props.user, props.account, router]);

    // Don't render the protected component if not authenticated
    if (!user && !props.user) {
      return null;
    }

    return (<WrappedComponent {...props}>{children}</WrappedComponent>);
  };

  FuncComponent.getInitialProps = async (ctx) => {
    let props = {};

    if (ctx && ctx.req) {
      let cookies = new Cookies(ctx.req?.headers?.cookie);
      if (cookies.get('tanukin_token')) {
        const res = await getStatus(ctx.req.headers.cookie);
        if (res.success) {
          const account = await getAccount(ctx.req.headers.cookie);
          props = { ...props, user: res.user, account: account };
        }
        else {
          props = { ...props, user: null, account: null };
        }
      }
    }

    // If Page/Component has a `getInitialProps`, we should call it... after? :)
    props = { ...props, ...WrappedComponent.getInitialProps && await WrappedComponent.getInitialProps(ctx) };
    return props;
  }

  return FuncComponent;
}

export default withAuth;